package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class FlashcardQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    skill_id: String?,
    front: String,
    back: String,
    note: String?,
    box: Long,
    due_date: String,
    last_review: String?,
    reviews: Long,
    lapses: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_110_753_475, arrayOf("flashcard"), driver, "Flashcard.sq",
      "selectAll",
      "SELECT flashcard.id, flashcard.skill_id, flashcard.front, flashcard.back, flashcard.note, flashcard.box, flashcard.due_date, flashcard.last_review, flashcard.reviews, flashcard.lapses, flashcard.order_index, flashcard.created_at, flashcard.updated_at, flashcard.is_deleted, flashcard.deleted_at, flashcard.synced_at FROM flashcard WHERE is_deleted = 0 ORDER BY due_date, order_index") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectAll(): Query<Flashcard> = selectAll { id, skill_id, front, back, note, box,
      due_date, last_review, reviews, lapses, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Flashcard(
      id,
      skill_id,
      front,
      back,
      note,
      box,
      due_date,
      last_review,
      reviews,
      lapses,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    skill_id: String?,
    front: String,
    back: String,
    note: String?,
    box: Long,
    due_date: String,
    last_review: String?,
    reviews: Long,
    lapses: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectById(id: String): Query<Flashcard> = selectById(id) { id_, skill_id, front, back,
      note, box, due_date, last_review, reviews, lapses, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Flashcard(
      id_,
      skill_id,
      front,
      back,
      note,
      box,
      due_date,
      last_review,
      reviews,
      lapses,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    skill_id: String?,
    front: String,
    back: String,
    note: String?,
    box: Long,
    due_date: String,
    last_review: String?,
    reviews: Long,
    lapses: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-2_010_076_556, arrayOf("flashcard"), driver, "Flashcard.sq",
      "selectDirty",
      "SELECT flashcard.id, flashcard.skill_id, flashcard.front, flashcard.back, flashcard.note, flashcard.box, flashcard.due_date, flashcard.last_review, flashcard.reviews, flashcard.lapses, flashcard.order_index, flashcard.created_at, flashcard.updated_at, flashcard.is_deleted, flashcard.deleted_at, flashcard.synced_at FROM flashcard WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectDirty(): Query<Flashcard> = selectDirty { id, skill_id, front, back, note, box,
      due_date, last_review, reviews, lapses, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Flashcard(
      id,
      skill_id,
      front,
      back,
      note,
      box,
      due_date,
      last_review,
      reviews,
      lapses,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    skill_id: String?,
    front: String,
    back: String,
    note: String?,
    box: Long,
    due_date: String,
    last_review: String?,
    reviews: Long,
    lapses: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Flashcard> = selectByIdAnyState(id) { id_,
      skill_id, front, back, note, box, due_date, last_review, reviews, lapses, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Flashcard(
      id_,
      skill_id,
      front,
      back,
      note,
      box,
      due_date,
      last_review,
      reviews,
      lapses,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    skill_id: String?,
    front: String,
    back: String,
    note: String?,
    box: Long,
    due_date: String,
    last_review: String?,
    reviews: Long,
    lapses: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(566_093_243, """
        |INSERT INTO flashcard(id, skill_id, front, back, note, box, due_date, last_review, reviews, lapses, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 13) {
          bindString(0, id)
          bindString(1, skill_id)
          bindString(2, front)
          bindString(3, back)
          bindString(4, note)
          bindLong(5, box)
          bindString(6, due_date)
          bindString(7, last_review)
          bindLong(8, reviews)
          bindLong(9, lapses)
          bindLong(10, order_index)
          bindLong(11, created_at)
          bindLong(12, updated_at)
        }
    notifyQueries(566_093_243) { emit ->
      emit("flashcard")
    }
  }

  public fun update(
    skill_id: String?,
    front: String,
    back: String,
    note: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(911_039_435,
        """UPDATE flashcard SET skill_id = ?, front = ?, back = ?, note = ?, updated_at = ? WHERE id = ?""",
        6) {
          bindString(0, skill_id)
          bindString(1, front)
          bindString(2, back)
          bindString(3, note)
          bindLong(4, updated_at)
          bindString(5, id)
        }
    notifyQueries(911_039_435) { emit ->
      emit("flashcard")
    }
  }

  public fun review(
    box: Long,
    due_date: String,
    last_review: String?,
    reviews: Long,
    lapses: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(815_536_730,
        """UPDATE flashcard SET box = ?, due_date = ?, last_review = ?, reviews = ?, lapses = ?, updated_at = ? WHERE id = ?""",
        7) {
          bindLong(0, box)
          bindString(1, due_date)
          bindString(2, last_review)
          bindLong(3, reviews)
          bindLong(4, lapses)
          bindLong(5, updated_at)
          bindString(6, id)
        }
    notifyQueries(815_536_730) { emit ->
      emit("flashcard")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_134_555_255,
        """UPDATE flashcard SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_134_555_255) { emit ->
      emit("flashcard")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-490_598_452,
        """UPDATE flashcard SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-490_598_452) { emit ->
      emit("flashcard")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-1_957_518_423,
        """UPDATE flashcard SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-1_957_518_423) { emit ->
      emit("flashcard")
    }
  }

  public fun syncUpdate(
    skill_id: String?,
    front: String,
    back: String,
    note: String?,
    box: Long,
    due_date: String,
    last_review: String?,
    reviews: Long,
    lapses: Long,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-408_587_962,
        """UPDATE flashcard SET skill_id = ?, front = ?, back = ?, note = ?, box = ?, due_date = ?, last_review = ?, reviews = ?, lapses = ?, order_index = ?, updated_at = ? WHERE id = ?""",
        12) {
          bindString(0, skill_id)
          bindString(1, front)
          bindString(2, back)
          bindString(3, note)
          bindLong(4, box)
          bindString(5, due_date)
          bindString(6, last_review)
          bindLong(7, reviews)
          bindLong(8, lapses)
          bindLong(9, order_index)
          bindLong(10, updated_at)
          bindString(11, id)
        }
    notifyQueries(-408_587_962) { emit ->
      emit("flashcard")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("flashcard", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("flashcard", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(73_660_656,
        """SELECT flashcard.id, flashcard.skill_id, flashcard.front, flashcard.back, flashcard.note, flashcard.box, flashcard.due_date, flashcard.last_review, flashcard.reviews, flashcard.lapses, flashcard.order_index, flashcard.created_at, flashcard.updated_at, flashcard.is_deleted, flashcard.deleted_at, flashcard.synced_at FROM flashcard WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Flashcard.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("flashcard", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("flashcard", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(728_767_253,
        """SELECT flashcard.id, flashcard.skill_id, flashcard.front, flashcard.back, flashcard.note, flashcard.box, flashcard.due_date, flashcard.last_review, flashcard.reviews, flashcard.lapses, flashcard.order_index, flashcard.created_at, flashcard.updated_at, flashcard.is_deleted, flashcard.deleted_at, flashcard.synced_at FROM flashcard WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Flashcard.sq:selectByIdAnyState"
  }
}
